/* ------ This is the Global enum definition.---------
 * Note: DO NOT change enum definition unless it won't break anything
 */

export const TYPE = {
  Programming: "ProgrammingsProducts",
  CoachingSubscription: "CoachingSubscriptionProducts",
  Membership: "MembershipProducts",
};
